// import useDebounce from '@/hooks/useDebounce'
// import useDebounce from '@/hooks/useDebounce'
import areaApi from '@/api/config/areaApi'
import { stationsApi } from '@/api/operations'
import ButtonFieldLight from '@/components/form-control/ButtonFieldLight'
import { FilterIcon, SearchIcon } from '@/components/icons'
import { useAuthContext } from '@/features/auth/context'
import { SearchParams } from '@/types'
import { AreaType } from '@/types/areaZone'
import {
  GetStationsBasedOnLocationParams,
  LocationFiltered,
} from '@/types/program'
import { Box, InputAdornment, InputBase, Stack } from '@mui/material'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import classes from './styles.module.scss'
import { useAppDispatch, useAppSelector } from '@store/stores'
import { useSelector } from 'react-redux'
import {
  EFilterType,
  EStationTab,
  fetchAllFilterData,
  stationGeoTagDeviceSliceActions,
  stationGeoTagDeviceState,
} from '@store/slices/StataionGeoTagDevice/stationGeoTagDeviceSlice'
import MenuFilterSiteLocationV2 from '@features/operations/components/common/MenuFilterSiteLocationV2'
import MenuFilterStationCXV2 from '@features/operations/components/pages/Programs/ProgramViewStation/MenuFilterStation/MenuFilterStationCXV2'
import ListFilterStationsV2 from '@features/operations/components/pages/Programs/components/ListFilterStations/ListFilterStationsV2'
import MenuFilterSensorType from '@features/operations/components/common/MenuFilterSensorType'
import { mode_type } from '@/theme/types/constants'
import { selectTheme } from '@store/selectors/ThemeSelector'

import useTranslation from '@/hooks/useTranslation'

const enum btnActive {
  sites = 'site-location',
  plants = 'plants',
  soil = 'soil',
  emmiter = 'emmiter',
}

const defaultEnd = new Date()
defaultEnd.setDate(defaultEnd.getDate() + 1)

export type FilterAction = 'add' | 'remove' | 'reset' | 'update'

export type FilterUpdateData = {
  action: FilterAction
  filterType?: 'PlantIds' | 'SoilIds' | 'EmitterIds' | 'SubAreaIds' | 'all'
  data: any
}

type ProgramsProps = {
  readonly openFull?: boolean
  readonly openMap?: boolean
  readonly locationId?: number
  readonly floorId?: number
  readonly removeAll: boolean
  readonly parentCallback: (showStations: boolean, showCheckId: boolean) => void
  readonly numberStation?: number
  readonly manualRun?: boolean
  readonly id?: string
  readonly tab?: string
  // readonly onFilterUpdate: (value: FilterUpdateData) => void
  // readonly onChangeKeyword: (value: string) => void
  readonly currentFilter: any
}

function StationFilterViewV2({
  openMap,
  openFull,
  removeAll,
  // onFilterUpdate,
  // onChangeKeyword,
  currentFilter,
}: Readonly<ProgramsProps>) {
  const { t } = useTranslation()

  const themeMode = useSelector(selectTheme)

  const { interfaceId } = useAuthContext()
  const [locationStations, setLocationStations] = useState<LocationFiltered[]>(
    [],
  )
  const [areaSub, setAreaSub] = useState<AreaType[]>([])
  const [areaIds, setAreaIds] = useState<number[]>()
  const [plants, setPlants] = useState<any[]>([])
  const [emitters, setEmitters] = useState<any[]>([])
  const [soils, setSoils] = useState<any[]>([])
  // //Filter
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [anchorElSite, setAnchorElSite] = useState<null | HTMLElement>(null)
  const [anchorElType, setAnchorElType] = useState<null | HTMLElement>(null)
  const formFilter = useForm()
  const [showStations, setShowStations] = useState(false)

  const [searchParams, setSearchParams] = useState<SearchParams>({
    PageSize: 0,
    // isRequiredEtZone: programMode === 'Run-Soil Moisture' ? true : false,
    isRequiredEtZone: false,
  })

  const dispatch = useAppDispatch()
  const stationGeoTagDevice = useAppSelector(stationGeoTagDeviceState)
  const tab = stationGeoTagDevice.tab

  const getAreaSub = async () => {
    const dataArea: AreaType[] = await areaApi
      .getAll({ interfaceId: Number(interfaceId), PageSize: 0 })
      .then((res) => res.data.data)
      .catch(() => [] as AreaType[])

    setAreaSub(dataArea)
  }

  const getLocationStations = async (
    filter: GetStationsBasedOnLocationParams,
  ) => {
    const data = await stationsApi
      .getStationsBasedOn(Number(interfaceId || 0), filter)
      .then((res) => res.data.data)
      .catch(() => [] as LocationFiltered[])
    setLocationStations(data)
  }

  useEffect(() => {
    if (removeAll) {
      setShowStations(false)
    }
  }, [removeAll, showStations, locationStations])

  useEffect(() => {
    if (interfaceId) {
      getLocationStations({
        PageSize: 0,
        ...searchParams,
      }).then(() => {
        dispatch(fetchAllFilterData(interfaceId))
      })
    }
  }, [interfaceId])

  useEffect(() => {
    getLocationStations({
      PageSize: 0,
      ...searchParams,
    })
    // eslint-disable-next-line
  }, [searchParams])

  const [keyword, setKeyword] = useState('')
  const handleSearch = (event: any) => {
    const value = event.target.value.toString().trim()
    setKeyword(value)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleOpenAreaSub = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElSite(event.currentTarget)
    setAnchorEl(null)
  }

  const handleOpenSensorType = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElType(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setAnchorElSite(null)
    setAnchorElType(null)
  }

  /**
   * DO NOT TOUCH
   * Generates filter configuration objects based on the specific group type identified by the `anchorEl.id`.
   * Handles different filter configurations for Sites & Locations, Plants, Emitters, and Soils.
   * Each filter configuration determines appropriate titles, placeholders, data-fetching functions, binding labels, and filter type names.
   *
   * @function
   * @returns {Object} An object representing the filter configuration for the specified*/
  const groupFilter = () => {
    switch (anchorEl?.id) {
      case btnActive.sites: {
        return {
          title: t('filterSitesLocationsByStation'),
          placeholder: t('stations.filter.searchSiteAndLocationName'),
          getOptions: getAreaSub,
          bindLabel: 'siteLocationName',
          name: EFilterType.LocationIds,
        }
      }
      case btnActive.plants: {
        return {
          title: t('filterPlantsByStation'),
          placeholder: t('stations.filter.searchPlantsName'),
          getOptions: stationGeoTagDevice.plants,
          bindLabel: 'description',
          name: EFilterType.PlantIds,
        }
      }
      case btnActive.emmiter: {
        return {
          title: t('filterEmitterByStation'),
          placeholder: t('stations.filter.searchEmitterName'),
          getOptions: stationGeoTagDevice.emitters,
          bindLabel: 'emitter',
          name: EFilterType.EmitterIds,
        }
      }
      case btnActive.soil: {
        return {
          title: t('filterSoilByStation'),
          placeholder: t('stations.filter.searchSoilName'),
          getOptions: stationGeoTagDevice.soils,
          bindLabel: 'description',
          name: EFilterType.SoilIds,
        }
      }
      default: {
        return {
          name: EFilterType.PlantIds,
        }
      }
    }
  }

  const getAreaSubFilter = () => {
    const subAreaIds =
      areaSub?.reduce(
        (rest: number[], item) =>
          rest.concat(
            item.subAreas
              ?.filter((temp) => temp.isSelected)
              ?.map((temp) => temp.id) || [],
          ),
        [],
      ) || []

    setAreaIds(subAreaIds)
    const data = {
      SubAreaIds: subAreaIds,
      PlantIds: plants?.map((item: any) => item.id) || 0,
      EmitterIds: emitters?.map((item: any) => item.id) || 0,
      SoilIds: soils?.map((item: any) => item.id) || 0,
    }

    setPlants(data.PlantIds)
    setEmitters(data.EmitterIds)
    setSoils(data.SoilIds)

    handleClose()
  }

  const handleFilterArea = () => {
    // getLocationStations(getAreaSubFilter())
    getAreaSubFilter()
  }

  useEffect(() => {
    setKeyword('')
  }, [tab])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(
        stationGeoTagDeviceSliceActions.changeKeywordForTab({
          tab,
          value: keyword,
        }),
      )
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [keyword, tab])

  const getSearchPlaceholder = (tab: EStationTab) => {
    switch (tab) {
      case EStationTab.StationData:
        return t('stations.searchStations')

      case EStationTab.FlowSensor:
        return t('SearchSensors')

      case EStationTab.SoilMoisture:
        return t('mapViewSearchSoilMoisture')

      case EStationTab.Sensor:
        return t('SearchSensors')
    }
  }

  return (
    <div className={clsx(classes.root, 'custom-scrollbar')}>
      <Stack flexGrow="1" className={classes.contentSelectedStations}>
        <Stack
          direction="row"
          className={clsx(classes.body, 'custom-scrollbar')}
        >
          <Box width="100%">
            <FormProvider {...formFilter}>
              <Stack
                direction="row"
                mt="15px"
                ml="15px"
                justifyContent="flex-start"
                gap={1}
              >
                <Stack direction="row">
                  <InputBase
                    name={t('stations.searchStations')}
                    placeholder={getSearchPlaceholder(tab)}
                    value={keyword}
                    onChange={handleSearch}
                    sx={{
                      width: '160px',
                      height: '32px',
                      backgroundColor: 'background.default',
                      border: {
                        ...(themeMode === mode_type.dark
                          ? { border: '1px solid #283d43' }
                          : { border: '1px solid #D7D7D7' }),
                      },
                      padding: '8px',
                      borderRadius: '5px',
                      boxShadow: '0px 0px 30px rgba(132, 132, 132, 0.25)',
                      '& .MuiInputBase-input::placeholder': {
                        color: 'text.main',
                      },
                      [`& .MuiInputBase-input`]: {
                        fontSize: '12px',
                        fontWeight: '600',
                        lineHeight: '100%',
                        color: 'text.main',
                      },
                    }}
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ color: '#747474' }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </Stack>

                {tab === EStationTab.StationData && (
                  <Stack direction="row" spacing={1}>
                    <Stack direction="row">
                      <ButtonFieldLight
                        id={btnActive.sites}
                        className={openFull || !openMap ? '' : classes.filter}
                        startIcon={<FilterIcon />}
                        style={{
                          height: '32px',
                          minWidth: '115px',
                          borderRadius: '5px',
                        }}
                        onClick={handleOpenAreaSub}
                        name={t('stations.list.areaAndSubArea')}
                      />
                    </Stack>

                    <Stack direction="row">
                      <ButtonFieldLight
                        id={btnActive.plants}
                        className={openFull || !openMap ? '' : classes.filter}
                        startIcon={<FilterIcon />}
                        style={{
                          height: '32px',
                          minWidth: '58px',
                          borderRadius: '5px',
                        }}
                        onClick={handleClick}
                        name={t('stations.filter.plants')}
                      />
                    </Stack>
                    <Stack direction="row">
                      <ButtonFieldLight
                        id={btnActive.emmiter}
                        className={openFull || !openMap ? '' : classes.filter}
                        startIcon={<FilterIcon />}
                        style={{
                          height: '32px',
                          minWidth: '65px',
                          borderRadius: '5px',
                        }}
                        onClick={handleClick}
                        name={t('stations.filter.emitters')}
                      />
                    </Stack>
                    <Stack direction="row">
                      <ButtonFieldLight
                        id={btnActive.soil}
                        className={openFull || !openMap ? '' : classes.filter}
                        startIcon={<FilterIcon />}
                        style={{
                          height: '32px',
                          minWidth: '44px',
                          borderRadius: '5px',
                        }}
                        onClick={handleClick}
                        name={t('stations.filter.soils')}
                      />
                    </Stack>
                  </Stack>
                )}

                {tab === EStationTab.Sensor && (
                  <Stack direction="row">
                    <ButtonFieldLight
                      startIcon={<FilterIcon />}
                      style={{
                        height: '32px',
                        minWidth: '58px',
                        borderRadius: '5px',
                      }}
                      onClick={handleOpenSensorType}
                      name={t('sensorType') || 'Type'}
                    />
                  </Stack>
                )}
              </Stack>

              {/* Popup Areas - Sub Area */}
              <MenuFilterSiteLocationV2
                anchorEl={anchorElSite}
                onClose={handleClose}
                handleFilterArea={handleFilterArea}
              />

              {/* Popup Sensor Type filter */}
              <MenuFilterSensorType
                anchorEl={anchorElType}
                onClose={handleClose}
              />

              {/* Popup Each Plants, Emitter, and Soil */}
              {anchorEl && <MenuFilterStationCXV2
                title={groupFilter().title}
                placeholder={groupFilter().placeholder}
                anchorEl={anchorEl}
                onClose={handleClose}
                bindLabel={groupFilter().bindLabel}
                name={groupFilter().name}
                handleFilter={() => {
                  handleClose()
                }}
              />}

            </FormProvider>
          </Box>
        </Stack>
        <Stack
          sx={{
            ml: '15px',
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            gap: '8px',
            maxWidth: '100%',
            alignItems: 'flex-start',
          }}
        >
          <ListFilterStationsV2 />
        </Stack>
      </Stack>
    </div>
  )
}

export default StationFilterViewV2
